import { API_BASE_URL } from "../urls.api";

export const GET_BOOKING_DETAILS = `${API_BASE_URL}/bookings-legacy/bookingdetails`;
export const GET_ROOM_DETAILS = `${API_BASE_URL}/rooms/roomdetails`;
export const GET_NOISE_LEVELS = `${API_BASE_URL}/monitors/noise-levels`;
